import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { LlPermissionsService } from '../ll-permissions.service';
import { LlExamService } from '../ll-exam.service';

@Component({
  selector: 'll-exam-sections-scope',
  templateUrl: './ll-exam-sections-scope.component.html',
  styleUrl: './ll-exam-sections-scope.component.css'
})
export class LlExamSectionsScopeComponent implements AfterViewInit {

  @ViewChild('mainDiv_ll_exam_sections_scope') mainDiv!: ElementRef;
  @ViewChild('descriptionEditor') descriptionEditor!: ElementRef;

  bundle = {
    showPanel: false,
    mode: '',
    function: '',
    parentW: 0,
    parentH: 0,
    panelX: 0,
    panelY: 20,
    panelW: 0,
    panelH: 0,
    questionList: [] as any[],
    prospectContactChoices: [] as any[],
    lenderContactChoices: [] as any[],
    examinerContactChoices: [] as any[],
    monthEndChoices: [] as any[],
    locationChoices: [] as any[],
    modalQuestion: null as any,
    selectedContactIds: new Set<string>(),
    selectedLocationIds: new Set<string>()
  };

  // Contact Modal
  showContactModal = false;
  contactChange = false;
  modalType: 'PROSPECT' | 'LENDER' | 'EXAMINER' = '' as any;
  modalTitle = '';
  showAddContactModal = false;

  newContact = {
    COMPANYID: null as any,
    CONTACTTITLE: '',
    CONTACTFIRST: '',
    CONTACTLAST: '',
    CONTACTEMAIL: '',
    TYPE: ''
  };

  // Description Editor Modal
  showDescriptionModal = false;
  editingDescriptionQuestion: any = null;
  originalDescriptionHtml = '';
  descriptionHasChanged = false;

  // Location Modal
  showLocationModal = false;
  locationChange = false;

  // Exam Parameters Modal
  showExamParamsModal = false;
  editingExamQuestion: any = null;
  tempExamThrough: string = '';
  tempExamMonthsBack: number | '' = '';

  constructor(
    private LlPermissionsService: LlPermissionsService,
    private LlExamService: LlExamService,
  ) { }

  ngAfterViewInit() {
    this.setVars();
  }

  setVars() {
    this.bundle.showPanel = false;
    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;
    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {
      this.bundle.panelW = this.bundle.parentW;
      this.bundle.panelH = this.bundle.parentH - this.bundle.panelY - 50;
    });

    this.getData();
  }

  getData() {
    this.LlExamService.NG_LL_model_exam_section_scope_get((arr: any[]) => {
      this.bundle.questionList = arr || [];
      this.bundle.prospectContactChoices = this.parseContactChoices(arr, 'PROSPECT_CONTACT_CHOICES');
      this.bundle.lenderContactChoices = this.parseContactChoices(arr, 'LENDER_CONTACT_CHOICES');
      this.bundle.examinerContactChoices = this.parseContactChoices(arr, 'EXAMINER_CONTACT_CHOICES');
      this.bundle.locationChoices = this.parseLocationChoices(arr);

      this.LlExamService.NG_utility_monthEnds_get((arr: any[]) => {
        this.bundle.monthEndChoices = arr || [];
        this.bundle.showPanel = true;
      });
    });
  }

  private parseContactChoices(arr: any[], fieldName: string): any[] {
    if (!arr || arr.length === 0) return [];
    const q = arr[0];
    const str = q[fieldName] || '';
    return str.split(',').map((item: string) => {
      const parts = item.split('^');
      return {
        CONTACTID: parts[0]?.trim(),
        DISPLAY: parts[1]?.trim() || parts[0]?.trim()
      };
    }).filter(c => c.CONTACTID);
  }

  private parseLocationChoices(arr: any[]): any[] {
    if (!arr || arr.length === 0) return [];
    const q = arr[0];
    const str = q.LOCATION_CHOICES || '';
    return str.split(',').map((item: string) => {
      const parts = item.split('^');
      return {
        LOCATIONID: parts[0]?.trim(),
        DISPLAY: parts[1]?.trim() || parts[0]?.trim()
      };
    }).filter(c => c.LOCATIONID);
  }

  // ==================== MAIN CONTACT MODAL ====================
  openContactsModal(q: any, type: 'PROSPECT' | 'LENDER' | 'EXAMINER') {
    this.bundle.modalQuestion = q;
    this.modalType = type;
    this.modalTitle = `Select ${type} Contacts`;
    this.contactChange = false;
    this.bundle.selectedContactIds.clear();
    const field = `${type}_CONTACTS`;
    const currentIds = (q[field] || '').trim();
    if (currentIds) {
      currentIds.split(',').map(id => id.trim()).filter(Boolean)
        .forEach(id => this.bundle.selectedContactIds.add(id));
    }
    this.showContactModal = true;
  }

  toggleContact(contactId: string | number): void {
    const idStr = String(contactId);
    this.contactChange = true;
    if (this.bundle.selectedContactIds.has(idStr)) {
      this.bundle.selectedContactIds.delete(idStr);
    } else {
      this.bundle.selectedContactIds.add(idStr);
    }
    if (this.bundle.modalQuestion) {
      const fieldName = `${this.modalType}_CONTACTS`;
      const updatedIds = Array.from(this.bundle.selectedContactIds).join(',');
      this.bundle.modalQuestion[fieldName] = updatedIds;
      this.LlExamService.NG_LL_model_exam_section_scope_edit(
        () => { this.getData(); },
        fieldName,
        updatedIds
      );
    }
  }

  closeContactModal(): void {
    this.showContactModal = false;
    this.bundle.modalQuestion = null;
    this.modalType = '' as any;
    this.bundle.selectedContactIds.clear();
  }

  isContactSelected(contactId: any): boolean {
    return this.bundle.selectedContactIds.has(String(contactId));
  }

  getContactChoices(): any[] {
    switch (this.modalType) {
      case 'PROSPECT': return this.bundle.prospectContactChoices;
      case 'LENDER': return this.bundle.lenderContactChoices;
      case 'EXAMINER': return this.bundle.examinerContactChoices;
      default: return [];
    }
  }

  // ==================== ADD NEW CONTACT ====================
  openAddContactModal() {
    this.newContact = {
      COMPANYID: null,
      CONTACTTITLE: '',
      CONTACTFIRST: '',
      CONTACTLAST: '',
      CONTACTEMAIL: '',
      TYPE: this.modalType
    };
    if (this.bundle.modalQuestion) {
      if (this.modalType === 'PROSPECT') {
        this.newContact.COMPANYID = this.bundle.modalQuestion.PROSPECT_COMPANYID;
      } else if (this.modalType === 'LENDER') {
        this.newContact.COMPANYID = this.bundle.modalQuestion.LENDER_COMPANYID;
      } else if (this.modalType === 'EXAMINER') {
        this.newContact.COMPANYID = this.bundle.modalQuestion.EXAMINER_COMPANYID;
      }
    }
    this.showAddContactModal = true;
  }

  saveNewContact() {
    if (!this.newContact.CONTACTTITLE || !this.newContact.CONTACTFIRST ||
      !this.newContact.CONTACTLAST || !this.newContact.CONTACTEMAIL) {
      alert("Title, First Name, Last Name, and Email are all required.");
      return;
    }
    console.log(`New ${this.modalType} Contact:`, this.newContact);
    this.showAddContactModal = false;
    this.LlExamService.NG_LL_model_exam_section_scope_contact_add(
      () => { this.getData(); },
      this.newContact
    );
  }

  closeAddContactModal() {
    this.showAddContactModal = false;
  }

  // ==================== DESCRIPTION EDITOR ====================
  openDescriptionEditor(q: any) {
    this.editingDescriptionQuestion = q;
    this.originalDescriptionHtml = q.PROSPECT_COMPANY_DESC_HTML || '';
    this.descriptionHasChanged = false;
    this.showDescriptionModal = true;

    setTimeout(() => {
      if (this.descriptionEditor?.nativeElement) {
        this.descriptionEditor.nativeElement.innerHTML = this.originalDescriptionHtml;
      }
    }, 100);
  }

  onDescriptionChange() {
    this.descriptionHasChanged = true;
  }

  saveDescriptionChanges() {
    if (!this.editingDescriptionQuestion || !this.descriptionEditor?.nativeElement) return;
    const newHtml = this.descriptionEditor.nativeElement.innerHTML.trim();
    this.editingDescriptionQuestion.PROSPECT_COMPANY_DESC_HTML = newHtml;
    this.LlExamService.NG_LL_model_exam_section_scope_edit(
      () => { this.getData(); },
      'PROSPECT_COMPANY_DESC_HTML',
      newHtml
    );
    this.closeDescriptionModal();
  }

  closeDescriptionModal() {
    this.showDescriptionModal = false;
    this.editingDescriptionQuestion = null;
    this.descriptionHasChanged = false;
  }

  // ==================== LOCATIONS MODAL ====================
  openLocationsModal(q: any) {
    this.bundle.modalQuestion = q;
    this.modalTitle = `Select Locations`;
    this.locationChange = false;
    this.bundle.selectedLocationIds.clear();

    const currentIds = (q.LOCATIONS || '').trim();
    if (currentIds) {
      currentIds.split(',').map(id => id.trim()).filter(Boolean)
        .forEach(id => this.bundle.selectedLocationIds.add(id));
    }
    this.showLocationModal = true;
  }

  toggleLocation(locationId: string | number): void {
    const idStr = String(locationId);
    this.locationChange = true;

    if (this.bundle.selectedLocationIds.has(idStr)) {
      this.bundle.selectedLocationIds.delete(idStr);
    } else {
      this.bundle.selectedLocationIds.add(idStr);
    }

    if (this.bundle.modalQuestion) {
      const updatedIds = Array.from(this.bundle.selectedLocationIds).join(',');
      this.bundle.modalQuestion.LOCATIONS = updatedIds;

      this.LlExamService.NG_LL_model_exam_section_scope_edit(
        () => { this.getData(); },
        'LOCATIONS',
        updatedIds
      );
    }
  }

  closeLocationsModal(): void {
    this.showLocationModal = false;
    this.bundle.modalQuestion = null;
    this.bundle.selectedLocationIds.clear();
  }

  isLocationSelected(locationId: any): boolean {
    return this.bundle.selectedLocationIds.has(String(locationId));
  }

  getLocationChoices(): any[] {
    return this.bundle.locationChoices;
  }

  // ==================== EXAM PARAMETERS MODAL ====================
  openExamParamsModal(q: any) {
    this.editingExamQuestion = q;
    this.tempExamThrough = q.EXAMTHROUGHMONTH || '';
    this.tempExamMonthsBack = q.EXAMMONTHSBACK || '';
    this.showExamParamsModal = true;
  }

  saveExamParamsModal() {
    if (!this.editingExamQuestion) return;

    const updates: any = {};
    if (this.tempExamThrough !== undefined) {
      this.editingExamQuestion.EXAMTHROUGHMONTH = this.tempExamThrough;
      updates.EXAMTHROUGHMONTH = this.tempExamThrough;
    }
    if (this.tempExamMonthsBack !== undefined) {
      this.editingExamQuestion.EXAMMONTHSBACK = this.tempExamMonthsBack;
      updates.EXAMMONTHSBACK = this.tempExamMonthsBack;
    }

    // Save each field
    Object.keys(updates).forEach(field => {
      this.LlExamService.NG_LL_model_exam_section_scope_edit(
        () => { this.getData(); },
        field,
        updates[field]
      );
    });

    this.closeExamParamsModal();
  }

  closeExamParamsModal() {
    this.showExamParamsModal = false;
    this.editingExamQuestion = null;
    this.tempExamThrough = '';
    this.tempExamMonthsBack = '';
  }

  // ==================== EXISTING METHODS ====================
  editCompany(q: any, type: 'PROSPECT' | 'LENDER' | 'EXAMINER') {
    console.log(`Edit clicked for ${type} company:`, q);
  }

  getQuestionValue(fieldName: string, studyQuestionId: number): any {
    const question = this.bundle.questionList.find(q => q.STUDYQUESTIONID === studyQuestionId);
    return question ? question[fieldName] : '';
  }

  onChanged(fieldName: string, newValue: string, studyQuestionId: number): void {
    this.setQuestionValue(fieldName, newValue, studyQuestionId);
  }

  setQuestionValue(fieldName: string, value: string, studyQuestionId: number): void {
    const question = this.bundle.questionList.find(q => q.STUDYQUESTIONID === studyQuestionId);
    if (question) question[fieldName] = value;
  }

  saveQuestion(studyQuestionId: number): void { }
}
